import { useState } from 'react'
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faSave } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

//Componets
import ModalCustomized from '../../../../components/Modal/Modal';
import TextField from '../../../../components/TextField';

//Helpers
import { objCampo, validarCampos } from '../../../../helpers/ValidadorDeCampos';
import { showMessage } from '../../../../helpers/message';

//API
import analiseInfracao_api from '../../../../api/analiseInfracao_api';
import { useAuth } from '../../../../context/auth';

export default function ModalInfracaoCancelamento({ infracaoCancelamento, setInfracaoCancelamento }) {
    const { setLoading } = useAuth();
    //Estado de navegação
    const navigate = useNavigate();

    //Estado de controle de errors no cancelamento da infração
    const [errors, setErrors] = useState({});

    //campos obrigatorios da finalizacao
    const camposInfracaoCancelamento = [
        objCampo({ name: "justificativaCancelamento", required: "true" }),
        objCampo({ name: "fiscalizacaoInfracao_Id", required: "true" }),
    ]

    function onChangeInfracaoCancelamento(e) {
        const { name, value } = e.target;

        const _infracaoCancelamento = {
            ...infracaoCancelamento
        };

        const _campos = camposInfracaoCancelamento.filter(campo => campo.name == name);
        const fieldError = validarCampos(_infracaoCancelamento, _campos);

        const _errors = { ...errors };
        delete _errors[name];
        if (fieldError[1].length === 0)
            setErrors({ ..._errors });
        else
            setErrors({ ..._errors, ...fieldError[0] });

        setInfracaoCancelamento({
            ...infracaoCancelamento,
            [name]: value
        })
    }

    const handleCancelarinfracao = async () => {
        const _errors = validarCampos(infracaoCancelamento, camposInfracaoCancelamento);
        setErrors(_errors[0]);

        if (_errors[1].length > 0)
            return true;

        setLoading(true);
        try {
            await analiseInfracao_api.CancelarInfracao(infracaoCancelamento);
            showMessage("Sucesso", "Sucesso na Operação", "success", () => {
                setInfracaoCancelamento({
                    fiscalizacaoInfracao_Id: "",
                    justificativaCancelamento: ""
                })
                navigate("/admin/dashboard");
            });
        } catch (error) {
            showMessage("aviso", error.message, "error", null);
        } finally {
            setLoading(false);
        }
    };

    function handleCloseModal() {
        setInfracaoCancelamento({ ...infracaoCancelamento, fiscalizacaoInfracao_Id: "" })
    }

    const isOpenModal = !!infracaoCancelamento.fiscalizacaoInfracao_Id;

    return (
        <ModalCustomized
            toggle={handleCloseModal}
            isOpen={isOpenModal}
            size={'lg'}
            fullscreen={"lg"}
            widthPadrao={false}
            title={"Cancelar Infração"}
        >
            <p className="text-danger p-0 m-0">* Tem certeza de que deseja cancelar a infração? Esta ação é irreversível.</p>
            <TextField
                name={"justificativaCancelamento"}
                label={"Justificativa do cancelamento"}
                type={"textarea"}
                maxLength={500}
                value={infracaoCancelamento.justificativaCancelamento}
                onChange={onChangeInfracaoCancelamento}
                invalid={!!errors.justificativaCancelamento}
            />
            <div className="d-flex justify-content-center align-items-center gap-2">
                <Button
                    color="danger"
                    onClick={handleCloseModal}
                >
                    <FontAwesomeIcon icon={faClose} /> Cancelar
                </Button>
                <Button
                    color="success"
                    onClick={handleCancelarinfracao}
                >
                    <FontAwesomeIcon icon={faSave} /> Confirmar
                </Button>
            </div>
        </ModalCustomized>

    )
}
